module.exports = __webpack_public_path__ + "static/media/production-newspaper.c86a18ea.jpg";